import React from "react";
import { Navigate } from "react-router-dom";

const LoginControlListComponent = React.lazy(
  () => import("../../../../../components/login-control/components/list/page"),
);

export const loginControlRoutes = [
  {
    path: "list",
    element: <LoginControlListComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/administration/login-control/list" />,
  },
];
